import { useRef, useState, useCallback, useEffect } from 'react';

export function usePolling(fetchFn, deps = {}) {
  const pollingRef = useRef(null);
  const [pollingActive, setPollingActive] = useState(false);

  const startPolling = useCallback(() => {
    if (pollingRef.current) return;
    setPollingActive(true);
    pollingRef.current = setInterval(async () => {
      try {
        const shouldStop = await fetchFn();
        if (shouldStop) stopPolling();
      } catch (err) {
        console.error('폴링 오류:', err);
        stopPolling();
      }
    }, 5000);
  }, [fetchFn]);

  const stopPolling = useCallback(() => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
    }
    setPollingActive(false);
  }, []);

  useEffect(() => {
    return () => stopPolling();
  }, [stopPolling]);

  return { pollingActive, startPolling, stopPolling };
}
